export default "__VITE_ASSET__DELLV3hw__"